import React from 'react';

const PaginationButtons = ({
  currentPage,
  setCurrentPage,
  goToPage,
  pages,
  hasNextPage,
  fetchNextPage,
}) => {
  return (
    <div className="flex flex-col md:flex-row md:items-center justify-center md:justify-end gap-3 md:gap-4 mt-4 md:mt-0">
      <nav aria-label="pagination">
        <ul className="flex items-center gap-1 md:gap-2 flex-wrap justify-center">
          {/* First page */}
          <li
            className={`page-item ${currentPage === 0 ? 'opacity-50 cursor-not-allowed' : ''
              }`}
          >
            <button
              onClick={() => goToPage(0)}
              disabled={currentPage === 0}
              className="flex h-9 w-9 items-center justify-center rounded-md border border-gray-300 text-gray-600 hover:bg-gray-100 disabled:hover:bg-transparent transition-colors"
              aria-label="First page"
            >
              <span className="material-symbols-outlined text-xl">first_page</span>
            </button>
          </li>

          {/* Previous page */}
          <li
            className={`page-item ${currentPage === 0 ? 'opacity-50 cursor-not-allowed' : ''
              }`}
          >
            <button
              onClick={() => goToPage(currentPage - 1)}
              disabled={currentPage === 0}
              className="flex h-9 w-9 items-center justify-center rounded-md border border-gray-300 text-gray-600 hover:bg-gray-100  disabled:hover:bg-transparent transition-colors"
              aria-label="Previous page"
            >
              <span className="material-symbols-outlined text-xl">chevron_left</span>
            </button>
          </li>

          {/* Page numbers */}
          {pages.map((_, i) => (
            <li key={i} className="page-item">
              <button
                onClick={() => goToPage(i)}
                className={`
                  flex h-9 w-9 items-center justify-center rounded-md text-sm font-medium transition-colors
                  ${currentPage === i
                    ? 'bg-blue-600 text-white border-blue-600'
                    : 'border border-gray-300 text-gray-700 hover:bg-gray-100'
                  }
                `}
              >
                {i + 1}
              </button>
            </li>
          ))}

          {/* Next page */}
          <li
            className={`page-item ${!hasNextPage ? 'opacity-50 cursor-not-allowed' : ''
              }`}
          >
            <button
              onClick={() => goToPage(currentPage + 1)}
              disabled={!hasNextPage}
              className="flex h-9 w-9 items-center justify-center rounded-md border border-gray-300 text-gray-600 hover:bg-gray-100 disabled:hover:bg-transparent transition-colors"
              aria-label="Next page"
            >
              <span className="material-symbols-outlined text-xl">chevron_right</span>
            </button>
          </li>

          {/* Jump +5 / Last (with prefetch) */}
          <li
            className={`page-item ${!hasNextPage ? 'opacity-50 cursor-not-allowed' : ''
              }`}
          >
            <button
              onClick={async () => {
                if (!hasNextPage) return;

                const targetPage = currentPage + 5;
                const fetchesNeeded = targetPage - (pages.length - 1);

                // Fetch missing pages if needed
                for (let i = 0; i < fetchesNeeded && hasNextPage; i++) {
                  await fetchNextPage();
                }

                // Go to target or last available page
                const maxPageIndex = pages.length - 1;
                setCurrentPage(Math.min(targetPage, maxPageIndex));
              }}
              disabled={!hasNextPage}
              className="flex h-9 w-9 items-center justify-center rounded-md border border-gray-300 text-gray-600 hover:bg-gray-100 disabled:hover:bg-transparent transition-colors"
              aria-label="Jump forward"
            >
              <span className="material-symbols-outlined text-xl cursor-pointer">last_page</span>
            </button>
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default PaginationButtons;